/**
 * Exports props for schema.org specifications
 * http://schema.org/
 */

// @flow
export default function schema({
  itemProp, itemType,
}: {
  itemProp: string,
  itemType: string,
}): Object {
  return {
    itemProp,
    itemScope: "itemScope",
    itemType: `http://schema.org/${itemType}`,
  };
}



// WEBPACK FOOTER //
// ./assets/pois/utils/schema.js